export const API_URL = process.env.REACT_APP_API_URL;
export const API_OK = "OK";
export const API_200 = 200;
export const API_201 = 201;
export const API_204 = 204;
export const API_403 = 403;
export const API_404 = 404;
export const API_EXCEPTION = "Exception";
export const DEFAULT_ERROR_TITLE = "Error";
export const DEFAULT_ERROR_TEXT = "network_error";
export const ERROR_SESSION_EXPIRED = "session_expired";
export const ERROR_BAD_SESSION = "bad_session";
export const ERROR_BAD_REQUEST = "bad_request";
export const INCORRECT_LOGIN_TYPE = "incorrect_login_type";
export const INCORRECT_LOGIN = "incorrect_login";

export const SHARE_URL = "https://links.kotvot.com";